/**
 * Whether setting Visa Results should collect visa dates (ReceivedVisaModal).
 * Skills Assessment services and the standalone Assessment service skip that
 * and PATCH success/fail, still sending visa_result on the status PUT.
 */
export function shouldCollectVisaDetails(programName?: string | null): boolean {
    const name = (programName ?? '').trim().toLowerCase();
    if (!name) {
        return true;
    }
    return name !== 'assessment' && !name.startsWith('skills assessment');
}
